export function formatDate(iso: string | null): string {
    if (!iso) return '—'
    const [year, month, day] = iso.split('-').map(Number)
    if (!year || !month || !day) return iso
    return new Intl.DateTimeFormat('es-ES', {day: '2-digit', month: 'short', year: 'numeric'}).format(new Date(year, month - 1, day))
}
